import { makeStyles, tokens } from '@fluentui/react-components';

export const useDailyHabitSectionStyles = makeStyles({
  container: {
    padding: tokens.spacingVerticalNone,
  },
  todayStatusIcon: {
    '& > svg': {
      width: tokens.fontSizeBase500,
      height: tokens.fontSizeBase500,
    },
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    padding: `${tokens.spacingVerticalXXXL} ${tokens.spacingHorizontalNone} ${tokens.spacingVerticalNone} ${tokens.spacingHorizontalS}`,
    marginTop: 'auto',
  },
  addButtonGap: {
    paddingRight: tokens.spacingHorizontalS,
  },
});
